<template>
  <div>
    <router-view
      :user.sync="user"
      :accepted_extensions="accepted_extensions"
      :prop_admin_user_uploaded_image.sync="prop_admin_user_uploaded_image"
      :prop_admin_user_img_name.sync="prop_admin_user_img_name">
    </router-view>
  </div>
</template>

<script>
  export default {

    data() {
      return {
        user: {},
        // ep_account_types: {}
        accepted_extensions: [],
        prop_admin_user_uploaded_image: '',
        prop_admin_user_img_name: '',
      }
    },

    methods: {
      getUser () {
        this.user = this.$store.getters['su_person_in_charge/User']
      },
      setEnums () {
        this.$loading.load(this.$auth.api.get('su/su_person_in_charges/init_new.json')
          .then(res => {
            this.user.su_company_id = res.data.su_company_id;
            this.accepted_extensions = res.data.accepted_extensions;
          })
          .catch(err => {
            this.$errorHandlers.initial(err);
          }));
      }
    },

    created: function(){
      this.getUser();
      this.setEnums();
    },
    beforeMount() {
      if(this.$route.name !== "SuPersonInChargeNewConfirm"){
        this.$store.commit('su_person_in_charge/initUser');
        this.user = this.$store.getters['su_person_in_charge/User'];
      }
    },

  }
</script>
